export interface AvailableDay {
  dateISO: string;
  slots: { time: string; modalities: string[] }[];
}

export interface Psychologist {
  id: string;
  nickname?: string;
  currency?: string;
  payment_method?: string;
  ranking_category?: 'A' | 'B' | 'C' | 'D' | 'F' | 'O' | 'N' | 'NZ';
  ranking_score?: number;
  process_limit?: number;
  process_limit_prefered?: number | null;
  status?: { id: string; name?: string };
  email?: string;
  timezone?: string | null;

  // English fields for app usage
  name?: string;
  last_name?: string;
  specialties?: string[];
  experience?: number;
  price?: number;
  image?: string;
  description?: string;
  rating?: number;
  availability?: AvailableDay[];
  modalities?: never;
  hasConfiguredSchedules?: boolean;

  // Backward compatibility with Spanish field names
  nombre?: string;
  apellido?: string;
  especialidades?: string[];
  experiencia?: number;
  precio?: number;
  imagen?: string;
  descripcion?: string;
  disponibilidad?: AvailableDay[];
  modalidades?: never;
  tieneHorariosConfigurados?: boolean;
}

export const psychologist: Psychologist = {
  id: 'usr4eV64Ha0NZ73qf',
  nickname: 'Cin',
  currency: 'USD',
  payment_method: 'foreign wire transfer',
  ranking_category: 'A',
  ranking_score: 2.34,
  process_limit: 35
};


